import styled from 'styled-components';

export const TagPickerElement = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  background-color: ${props => props.theme.vars.newColor.lightGS1};
  border-radius: 5px;
  width: 100%;

  &&&&& > * {
    margin: 10px;
  }
` as any;
